import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Loader from "../../../components/Loader";
import useAuth from "../../../components/hooks/useAuth";



const BroadcastsModalCreate = ({ setShowCreate, showCreate }) => {
  const [broadcastTitle, setBroadcastTitle] = useState("");
    const [loading, setLoading] = useState(false);
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

  const navigate = useNavigate();

  
    const createBroadcast = async () => {

      if(!broadcastTitle){
        return;
      }
  
      setLoading(true);
      try {
        let response = await postApi("/api/v1/wpbroadcast/create", {
          name:broadcastTitle
        });

        navigate('/broadcast/' + response.id)
  
      } catch (error) {
        window.alert("Erro ao carregar:", error);
        // Aqui você pode tratar o erro (ex: toast de aviso)
      } finally {
  
        setLoading(false);
      }
    }
   


  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>


      {showCreate && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.35)',
          zIndex: 999999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, minWidth: 360, boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
            <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#005c53' }}>Criar Broadcast</div>
            <input
              type="text"
              placeholder="Título"
              value={broadcastTitle}
              onChange={e => setBroadcastTitle(e.target.value)}
              style={{ width: '100%', padding: 10, fontSize: 16, border: '1px solid #ccc', borderRadius: 8, marginBottom: 12 }}
            />
            {/* Apenas input do nome do Broadcast conforme solicitado */}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={() => { setShowCreate(false); }} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
              <button
                onClick={() => createBroadcast()}
                style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#51a197', color: '#fff', fontWeight: 600, cursor: 'pointer' }}
                disabled={!broadcastTitle.trim()}
              >
                Criar
              </button>
            </div>
            
          {loading && <Loader />}
          </div>
        </div>
      )}
    </div>
  );
};

export default BroadcastsModalCreate;